module.exports = __webpack_public_path__ + "angular-development.3FV1eiVL.svg";